var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/camera",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 4.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,11.8889 C6.791,11.8889 5,10.0979 5,7.8889 C5,5.6799 6.791,3.8889 9,3.8889 C11.209,3.8889 13,5.6799 13,7.8889 C13,10.0979 11.209,11.8889 9,11.8889 M16,2.8889 L14.24,2.8889 L13.2,-0.0001 L4.8,-0.0001 L3.76,2.8889 L2,2.8889 C0.896,2.8889 0,3.7849 0,4.8889 L0,10.8889 C0,11.9929 0.896,12.8889 2,12.8889 L16,12.8889 C17.104,12.8889 18,11.9929 18,10.8889 L18,4.8889 C18,3.7849 17.104,2.8889 16,2.8889",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7.8889 C11,8.9929 10.104,9.8889 9,9.8889 C7.896,9.8889 7,8.9929 7,7.8889 C7,6.7849 7.896,5.8889 9,5.8889 C10.104,5.8889 11,6.7849 11,7.8889",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cbf5b497c8b7c64efe5676409f2524c9.svg";
export { ForwardRef as ReactComponent };